import React, { useState } from 'react';
import './styles.scss';
import i18next from 'i18next';

interface ExpandableTextTileProps {
    headline: string;
    children: React.ReactNode;
}

export default function ExpandableTextTile({ headline, children }: ExpandableTextTileProps): JSX.Element {
    const [expand, setExpand] = useState(false);

    return (
        <article className='expandable-text-tile'>
            <h3>{headline}</h3>
            <div className={`children ${expand ? 'expand' : ''}`}>{children}
            <div className={`shadow ${expand ? 'hide' : ''}`} /></div>
            <button onClick={() => setExpand(!expand)}>
                {expand ? i18next.t('showLess') : i18next.t('showMore')}
            </button>
        </article>
    );
}
